import React, {Component} from "react";
import {connect} from 'react-redux';
import {TwitterPicker} from 'react-color';

import "../../../asset/style/neoviewer/grid_overlay.css"
import {Checkbox, Divider, Input, Stack, ToggleButton, ToggleButtonGroup, Typography} from "@mui/material";
import {StyledLabelButton, StyledSlider1, StyledSlider2, StyledSwitch} from "../components/StyledComponents";
import {
	updateCircleLayerStatus,
	updateGridColor,
	updateGridDynamic,
	updateGridFullExtent,
	updateGridSpacing,
	updateGridStatus,
	updateGridStepCord,
	updateGridWidth
} from "../../../redux_actions/maps.state.action";
import {mapGridStateToProps} from "../../../redux_reducers/utils";
import {AppSubtitle, AppTitle} from "../components/components";
import {isNull} from "../../../utils/utils";
import {notifyInfo, notifySuccess} from "../utils/display.notification";

class GridOverlay extends Component {

	componentDidMount() {
		if (!this.props.dynamic && (this.props.displaySetting || {})["rotation"] % 360 > 0) {
			notifySuccess('grid', "Static Grid disabled for non-zero Rotation");
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (!this.props.dynamic && prevProps.displaySetting?.rotation !== this.props.displaySetting?.rotation && this.props.displaySetting?.rotation % 360 > 0) {
			notifySuccess('grid', "Static Grid disabled for non-zero Rotation");
		}
	}

	toggleGrid = (componentDisabled) => componentDisabled ? notifySuccess('grid', "Static Grid disabled for non-zero Rotation")
		: this.props.dispatch(updateGridStatus(this.props.activeMapId, !this.props.grid));

	toggleCircleLayer = () => this.props.dispatch(updateCircleLayerStatus(this.props.activeMapId, !this.props.circleLayer));

	updateWidth = (event, width) => this.props.dispatch(updateGridWidth(this.props.activeMapId, width));

	updateColor = color => this.props.dispatch(updateGridColor(this.props.activeMapId, color.hex));

	updateSpacing = (event, size) => this.props.dispatch(updateGridSpacing(this.props.activeMapId, size));

	toggleFullExtent = () => this.props.dynamic ?
		notifyInfo("extent-grid", "Dynamic grid can only be used with full extent") :
		this.props.dispatch(updateGridFullExtent(this.props.activeMapId, !this.props.fullExtent));

	updateDynamic = (event, dynamic) => this.props.dispatch(updateGridDynamic(this.props.activeMapId,
		isNull(dynamic) ? this.props.dynamic : dynamic));

	updateStepCord = event => this.props.dispatch(updateGridStepCord(this.props.activeMapId, event.target.value));


	// TODO: [Priyanshu] Dynamic grid
	render() {
		const microscopeSize = 500;
		let isDisabled = !this.props.dynamic && (this.props.displaySetting || {})["rotation"] % 360 > 0;
		let isDisabled2 = this.props.dynamic && (this.props.displaySetting || {})["rotation"] % 360 > 0;
		return <Stack direction={"column"}>
			<AppTitle title={"Grid Overlay"}/>
			<Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
				<Typography color={"whitesmoke"}>Enable</Typography>
				<StyledSwitch color={"secondary"}
							  checked={this.props.grid} onChange={() => this.toggleGrid(isDisabled)}/>
			</Stack>
			<Divider style={{margin: "10px"}}/>
			<AppSubtitle title={"Width"}/>
			<StyledSlider1 min={2} max={6} value={this.props.width} onChange={this.updateWidth}
			               valueLabelDisplay="auto"/>
			<Divider style={{margin: "10px"}}/>
			<AppSubtitle title={"Color"}/>
			<div style={{margin: 2}}>
				<TwitterPicker triangle={""} onChange={this.updateColor}/>
			</div>
			<Divider style={{margin: "10px"}}/>
			<AppSubtitle title={"Spacing"}/>
			<StyledSlider2 min={100} max={1500} step={5} value={this.props.spacing}
			               onChange={this.updateSpacing} valueLabelDisplay="auto"
						   color={"sliderDefaultColor"}
			               marks={[
				               {
					               value: microscopeSize,
				               }
			               ]}/>
			<StyledLabelButton variant="text" disableRipple
				style={{color: this.props.spacing === microscopeSize ? '#00FFFF' : '#FFFFFF'}}
				onClick = {event => this.updateSpacing(event, microscopeSize)}
			>
				<strong className="unselectable">micro<br/>scope</strong>
			</StyledLabelButton>
			<Divider style={{margin: "10px"}}/>
			<Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
				<Typography color={"whitesmoke"}>Grid Type</Typography>
				<ToggleButtonGroup value={this.props.dynamic} onChange={this.updateDynamic} exclusive
				                   color={"secondary"}>
					<ToggleButton value={false} sx={{color: '#94b4ff'}} disabled={isDisabled2}>
						<Typography variant={"caption"}>Static</Typography>
					</ToggleButton>
					<ToggleButton value={true} sx={{color: '#94b4ff'}}>
						<Typography variant={"caption"}>Dynamic</Typography>
					</ToggleButton>
				</ToggleButtonGroup>
			</Stack>
			<Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
				<Typography color={"whitesmoke"}>Full Extent</Typography>
				<Checkbox color={"secondary"} checked={this.props.fullExtent || this.props.dynamic}
				          onClick={this.toggleFullExtent}/>
			</Stack>
			<Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
				<Typography color={"whitesmoke"}>Step Coordinates</Typography>
				<Input value={this.props.stepCord} size={'small'} sx={{width: '50px', paddingX: 2}}
				       onChange={this.updateStepCord}
				       inputProps={{min: 0, max: 5, type: 'number'}}/>
			</Stack>
			<Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
				<Typography color={"whitesmoke"}>Enable Circle Layer</Typography>
				<StyledSwitch color={"secondary"} disabled={isDisabled}
							  checked={this.props.circleLayer} onChange={this.toggleCircleLayer}/>
			</Stack>
		</Stack>;
	}
}

export default connect(mapGridStateToProps)(GridOverlay);
